import { SuggestedTemplatesDirective } from './directive';
export { SuggestedTemplatesController } from './controller';

angular.module('app').directive('dsSuggestedTemplates', [SuggestedTemplatesDirective]);
